<template>
  <section class="vh-100 login">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-5 px-0 d-none d-sm-block triangle-left">
          <div class="login__logo">
            <!-- <h1>Ecoles</h1> -->
            <!-- <p>Platforme Education <br />Culture & Sport</p> -->
            <img src="../../assets/icons/logo-ecole.svg" alt="logo" />
          </div>
        </div>
        <div class="col-sm-12 col-md-7 g-0 text-black skew-triangle">
          <div class="login__connexion">
            <div class="px-5 ms-xl-4 login__connexion__logo">
              <!-- <h2 class="h1 fw-bold mb-0">Ecoles</h2> -->
            </div>

            <div class="d-flex align-items-center h-custom-2 px-5 ms-xl-4 mt-5 pt-5 pt-xl-0 mt-xl-n5">
              <form style="width: 23rem">
                <h3 class="mb-3 pb-3" style="letter-spacing: 1px">
                  {{ $t("title.connexion") }}
                </h3>

                <!-- <div v-if="adminAccountError" class="text-danger mb-3"> {{ $t("error.accessRights") }} </div> -->
                <div v-if="adminAccountError" style="background-color: white; color: red; border: radius 0.5em;" class="mb-3">
  {{ $t("error.accessRights") }}
</div>


                <div class="form-outline input-wrapper mb-4">
                  <div class="input-icon-wrapper input-icon-wrapper--login">
                    <input
                      id="form2Example18"
                      v-model="email"
                      type="email"
                      class="form-control form-control-lg style-input1"
                      :class="v$.email.$error === true ? 'text-fields-error' : ''"
                      autocomplete="off"
                    />
                  </div>

                  <span v-if="v$.email.$error" class="invalid-feedback"> {{ $t("authentification.invalidMail") }} </span>
                </div>

                <div class="form-outline input-wrapper mb-4">
                  <div class="input-icon-wrapper input-icon-wrapper--password">
                    <input
                      id="form2Example28"
                      v-model="password"
                      :type="passwordType ? 'password' : 'text'"
                      class="form-control form-control-lg style-input1"
                      :class="v$.password.$error ? 'text-fields-error' : ''"
                      autocomplete="off"
                    />
                    <i :class="passwordType ? 'icon-Show-eye' : 'icon-eyes'" @click.prevent="setPasswordType" />
                  </div>
                  <span v-if="v$.password.$error" class="invalid-feedback">{{ v$.password.$errors[0].$message }}</span>
                </div>
                <span v-if="Errormessage == true" style="color: red; font-size: 12px">{{ $t("authentification.invalidName") }}</span>
                <div class="control--checkbox">
                  <!-- <label class="container-checkbox">
                                        <input
                                            type="checkbox"
                                            v-model="accept"
                                        />
                                        <span class="caption"
                                            >J’accepte
                                            <a href="#"
                                                >les conditions générales</a
                                            >
                                            d’utilisation</span
                                        >
                                        <span class="checkmark"></span>
                  </label>-->
                  <!-- <div class="input-wrapper">
                                        <span
                                            class="invalid-feedback"
                                            v-if="v$.accept.$error"
                                        >
                                            {{ v$.accept.$errors[0].$message }}
                                        </span>
                  </div>-->
                </div>

                <div class="pt-1 mb-4 button-login">
                  <button class="btn btn-outline-primary button" :disabled="loading" @click.prevent="submitForm">
                    {{ $t("button.connect") }}
                    <i class="icon-Arrow" />
                  </button>
                </div>

                <p class="small mb-5 pb-lg-2">
                  <router-link :to="{name: 'password'}">
                    {{ $t("authentification.forgetpassword") }}
                  </router-link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
      <FooterElement />
    </div>
  </section>
</template>

<script>
import useValidate from "@vuelidate/core";
import {required, email, helpers} from "@vuelidate/validators";
import FooterElement from "../../components/navigation/Footer.vue";
// const mustBeTrue = (value) => value == true;
export default {
  name: "LoginPage",
  border: true,
  components: {
    FooterElement,
  },
  data() {
    return {
      v$: useValidate(),
      loading: false,
      email: "",
      password: "",
      passwordType: true,
      accept: false,
      Errormessage: false,
      adminAccountError: false,
    };
  },
  validations() {
    return {
      email: {
        required: helpers.withMessage("Adresse email est obligatoire !", required),
        email,
      },
      password: {
        required: helpers.withMessage("Le mot de passe est obligatoire !", required),
      },
      // accept: {
      //     required: helpers.withMessage("Accept is required", mustBeTrue),
      // },
    };
  },
  computed: {
    //...mapGetters(["currentUser"]),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },

  created() {
    if (this.loggedIn) {
      const adminStatus = localStorage.getItem("admin_account_status");
      if (parseInt(adminStatus) === 1) {
        this.adminAccountError = true;
        this.$router.push("/login");
      } else {
        this.$router.push("/");
        
      }
    }
  },
  methods: {
    submitForm() {
      this.loading = true;
      this.v$.$validate(); // checks all inputs
      if (!this.v$.$error) {
        let user = {
          email: this.email,
          password: this.password,
        };
        this.$store.dispatch("auth/login", user).then(
          (user) => {
            localStorage.setItem("admin_account_status", user.admin_account_status);

            if (user.admin_account_status === 1) {
              this.adminAccountError = true;
              this.loading = false;
            } else {
              this.adminAccountError = false;
              localStorage.setItem("school_category", user.school_category);

              user.role?.map((rol) => {
                if (rol.name === "admin_school" || rol.name === "parent" || rol.name === "teacher") {
                  this.$router.push("/");
                } else {
                  this.$router.push("/listecole");
                }
              });
              this.loading = false;
            }
          },
          () => {
            this.Errormessage = true;
            this.loading = false;
          }
        );
      } else {
        this.loading = false;
      }
    },
    setPasswordType() {
      this.passwordType = !this.passwordType;
    },
  },
};
</script>
<style>
.login .footer {
  position: absolute;
  z-index: 10;
  //margin-right: 95px;
  margin-bottom: -15px;
}
.login .footer span {
  color: #333;
}
.login .footer a {
  color: #34b9bb;
}
</style>
